import React, { useState } from 'react'
import { Panel, Row, Col, SelectPicker, DatePicker, Table, IconButton, Icon } from 'rsuite'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, LOCAL_DAY_TH, REQUEST_DATE_FORMAT } from '../../constants/date'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { doneLoading, startLoading } from '../../utils/loading'
import { callCashReport, downloadCashReportPdf } from '../../redux/actions/accountingReport'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { downloadFile } from '../../utils/fileUtil'

export default function CashReportWidget({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [category, setCategory] = useState()
  const [tableData, setTableData] = useState(schema?.datas?.values || [])

  const projectCode = sessionStorage.getItem('projectCode')
  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const [period, setPeriod] = useState()

  const handleSearch = () => {
    var request = {}
    if (period) {
      request.period = period
    }
    // console.log('test', period)

    // category: category,
    request.startDate = startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null
    request.endDate = endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null
    // pageNo: 1,
    // pageSize: 99,

    handleGetSchema(request)
  }

  const handleCancel = () => {
    const request = {}
    setStartDate(null)
    setEndDate(null)
    setPeriod(null)
    setCategory()

    handleGetSchema(request)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await callCashReport(projectCode, request)
      // console.log('schemaaaa => ', _schema.model.datas.values)
      setTableData(_schema.model.datas.values || [])
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnExportPdf = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _startDate = startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : ''
      const _endDate = endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : ''

      const file = await downloadCashReportPdf(projectCode, period, _startDate, _endDate)
      console.log('file ', file)
      if (file) {
        downloadFile(file, `รายการเงินสด_${projectCode}.pdf`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={''} bordered expanded>
        <MiniProjectInfo schema={formSchema?.projectInfo} />
        <br />
        {schema.searchForm.period && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <b>{schema.searchForm.period.label} : </b>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SelectPicker
                searchable={false}
                data={schema.searchForm.period.options}
                value={period}
                block
                placeholder={schema?.searchForm?.period?.placeholder || ''}
                onChange={(value) => {
                  setPeriod(value)
                }}
              />
            </Col>
          </Row>
        )}

        {/* วันที่ */}
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.searchForm.startDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <DatePickerCustom
              value={startDate}
              onChange={(value) => {
                setStartDate(value)
              }}
              placement="auto"
              disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.searchForm.endDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <DatePickerCustom
              value={endDate}
              onChange={(value) => {
                setEndDate(value)
              }}
              placement="auto"
              disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
            />
          </Col>
        </Row>

        {/* <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.searchForm.category.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SelectPicker
              searchable={false}
              value={category}
              data={formSchema.searchForm.category.options}
              block
              onChange={value => {
                setCategory(value)
              }}
            />
          </Col>
        </Row> */}

        <Row style={{ marginTop: 15 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <SearchButton disabled={false} onClick={handleSearch}>
              ค้นหา
            </SearchButton>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
              style={{ marginTop: -10 }}
              onClick={handleOnExportPdf}
            >
              Export to PDF
            </IconButton>
            {`  `}
            <CancelButton disabled={false} onClick={handleCancel}>
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>

        <Table
          wordWrap
          minHeight={400}
          autoHeight
          loading={isLoading}
          data={tableData}
          style={{ marginTop: 10 }}
          headerHeight={fs < 16 ? 40 : fs <= 18 ? 45 : 50}
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell dataKey="rowNumber" />
            {/* <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell> */}
          </Column>

          <Column width={150} align="center">
            <HeaderCell style={styleHeaderCell}>วันที่เอกสาร</HeaderCell>
            <Cell dataKey="docDate" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell style={styleHeaderCell}>เลขที่ใบสำคัญ</HeaderCell>
            <Cell dataKey="docNumber" />
          </Column>

          <Column width={280} minWidth={280} flexGrow={1}>
            <HeaderCell style={styleHeaderCell}>รายการ/หมวดบัญชี</HeaderCell>
            <Cell dataKey="detail" />
          </Column>

          <Column width={150} align="right">
            <HeaderCell style={styleHeaderCell}>รับ (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return rowData.deposit ? budgetFormat(rowData.deposit) : '-'
              }}
            </Cell>
          </Column>
          <Column width={150} align="right">
            <HeaderCell style={styleHeaderCell}>จ่าย (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return rowData.withdraw ? budgetFormat(rowData.withdraw) : '-'
              }}
            </Cell>
          </Column>
          <Column width={150} align="right">
            <HeaderCell style={styleHeaderCell}>คงเหลือ (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.balance || 0)
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
